export const iconFontAwesomeAnimalsShrimp = (
	<i className="fa-solid fa-shrimp"></i>
);
